import { render } from "./ResourceNotFound.vue?vue&type=template&id=71cbd40b&scoped=true&ts=true"
import script from "./ResourceNotFound.vue?vue&type=script&lang=ts"
export * from "./ResourceNotFound.vue?vue&type=script&lang=ts"

import "./ResourceNotFound.vue?vue&type=style&index=0&id=71cbd40b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cbd40b"]])

export default __exports__